import styled from "styled-components";
export const Container = styled.div`
  min-height: 100vh;
  background: #e4f0ed;
  padding: 155px 263px 196px 263px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ApprovalGifImage = styled.img`
  background: url(5202-review-id.png);
`;
export const ImageContainer = styled.div`
  width: 330px;
  height: 271.07px;
`;
export const HeaderText = styled.h1`
  font-family: "Adobe Clean";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  /* identical to box height, or 50% */
  color: #0e0e2c;
`;
export const BodyText = styled.p`
  font-family: "Adobe Clean";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #3b3950;
`;
